import { render, staticRenderFns } from "./Indonesia.vue?vue&type=template&id=14c8998b&"
import script from "./Indonesia.vue?vue&type=script&lang=js&"
export * from "./Indonesia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c8998b')) {
      api.createRecord('14c8998b', component.options)
    } else {
      api.reload('14c8998b', component.options)
    }
    module.hot.accept("./Indonesia.vue?vue&type=template&id=14c8998b&", function () {
      api.rerender('14c8998b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Indonesia.vue"
export default component.exports